import AppointmentsInnerNavigation from "./AppointmentsInnerNavigation";

export default AppointmentsInnerNavigation;
